exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.widget-user-image {\r\n  background-position: center center;\r\n  background-size: cover;\r\n  height: 250px;\n}\n.widget-user .card-footer {\r\n  padding-top: 25px !important;\r\n  /*  padding-bottom: 0 !important; */\n}\r\n", ""]);

// exports
